export const resumes = [
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
  {
    level: "Mid-level",
    resumeTitle: "Data Scientist Resume",
    company: "Technology and Software",
  },
];

export const resumeFilters = [
  "All",
  "Finance",
  "Engineering",
  "Technology",
  "Marketing",
  "Sales",
  "Operations",
  "Human Resources",
  "Legal",
  "Creative",
  "Other",
];
export const loaderResumes = [
  "All",
  "Finance",
  "Engineering",
  "Technology",
  "Marketing",
  "Sales",
  "Operations",
  "Human Resources",
];

export const industryList = [
  "All",
  "Healthcare",
  "Finance",
  "Technology",
  "Education",
  "Retail",
  "Manufacturing",
  "Construction",
];

export const careerList = ["All", "Entry", "Mid", "Senior", "Executive"];
export const regionList = ["North America", "Middle East", "South Asia"];
